"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _configuratorCarousel = _interopRequireDefault(require("../styles/configurator-carousel.css"));

var _controlsProgressButton = _interopRequireDefault(require("./controls-progress-button"));

var _controlsProgressNumbers = _interopRequireDefault(require("./controls-progress-numbers"));

var ConfiguratorCarouselControls = function ConfiguratorCarouselControls(_ref) {
  var handleNextSlide = _ref.handleNextSlide,
      handlePrevSlide = _ref.handlePrevSlide,
      visibleImageIndex = _ref.visibleImageIndex,
      carouselImagesLength = _ref.carouselImagesLength,
      theme = _ref.theme,
      isLowControls = _ref.isLowControls;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorCarousel["default"].controls + " " + (isLowControls ? _configuratorCarousel["default"].lowControls : '')
  }, /*#__PURE__*/_react["default"].createElement(_controlsProgressButton["default"], {
    handleChangeSlide: handlePrevSlide,
    buttonLabel: "Previous",
    carouselImagesLength: carouselImagesLength,
    theme: theme
  }), /*#__PURE__*/_react["default"].createElement(_controlsProgressNumbers["default"], {
    visibleImageIndex: visibleImageIndex,
    carouselImagesLength: carouselImagesLength,
    theme: theme
  }), /*#__PURE__*/_react["default"].createElement(_controlsProgressButton["default"], {
    handleChangeSlide: handleNextSlide,
    buttonLabel: "Next",
    carouselImagesLength: carouselImagesLength,
    theme: theme
  }));
};

var _default = ConfiguratorCarouselControls;
exports["default"] = _default;